export const PRE_APPROVAL_NOTIFY_LABEL =
  'Notify assigned team members when application pre-approved'

export const PRE_APPROVAL_NOTIFY_TOOLTIP =
  'When enabled, team members assigned to the property will receive an email when an application is moved to Pre-Approved.'

export const PREMIER_UPGRADE_TOOLTIP_SUFFIX = 'Available on Premier Plans.'

export const TEAM_ADMIN_UPDATE_TOOLTIP_SUFFIX = 'Team admin can update.'

export const getPreApprovalNotifyTooltipText = ({
  isAccountPremier,
  isUserAdmin,
}: {
  isAccountPremier: boolean
  isUserAdmin: boolean
}): string =>
  `${PRE_APPROVAL_NOTIFY_TOOLTIP} ${
    !isAccountPremier
      ? PREMIER_UPGRADE_TOOLTIP_SUFFIX
      : !isUserAdmin
      ? TEAM_ADMIN_UPDATE_TOOLTIP_SUFFIX
      : ''
  }`.trim()
